import {
    CHANGE_STEP,
    UPDATE_STEP,
    COMPLETE_SETUP_REQUEST,
    COMPLETE_SETUP_SUCCESS,
    COMPLETE_SETUP_FAILURE,
    DECREASE_TIMER,
    GET_SETUP_STATE_REQUEST,
    GET_SETUP_STATE_FAILURE,
    RESEND_VERIFICATION_CODE_REQUEST,
    RESEND_VERIFICATION_CODE_SUCCESS,
    RESEND_VERIFICATION_CODE_FAILURE,
    ACTIVATE_DENWA_NANO_REQUEST,
    ACTIVATE_DENWA_NANO_SUCCESS,
    ACTIVATE_DENWA_NANO_FAILURE,
    SET_LICENCE_STATUS
} from '../actions/wizardActionTypes';
import { LOG_OUT } from '../../auth/actions/authActionTypes';
import { updateTimer, updateStep } from '../helpers/wizardHelpers';

const initialState = {
    activeStep: 1,
    isCompleting: false,
    completed: false,
    error: false,
    isResending: false,
    resent: false,
    resendError: false,
    alternativeEmail: '',
    licenceStatus: '',
    isActivating: false,
    activated: false,
    activationError: false,
    activationCode: '',
    timer: 50,
    steps: [{
        key: 'introduction',
        title: 'INTRODUCTION',
        Optional: false
    }, {
        key: 'general',
        title: 'GENERAL',
        description: 'GENERAL_PERSONALIZED_ATTENTION GENERAL_LOCALIZATION GENERAL_DIALIGN',
        Optional: false,
        Completed: false,
        AbleToComplete: false,
        CompanyName: '',
        CompanyContact: '',
        CompanyPhone: '',
        CompanyEmail: '',
        AreaCode: '',
        CompanyCountry: '',
        CompanyState: '',
        CompanyCity: '',
        DefaultLanguage: '',
        TimeZone: ''
    }, {
        key: 'networking',
        title: 'NETWORKING',
        description: 'NETWORKING_CONNECTIVIY NETWORKING_SWITCH_MODE NETWORKING_ROUTE_MODE NETWORKING_DHCP',
        Optional: false,
        Completed: false,
        AbleToComplete: false,
        InitialValid: false,
        Method: '',
        DNSServer: '',
        LAN: {
            Method: '',
            IPAddress: '',
            Netmask: '',
            Gateway: '',
            Status: ''
        },
        WAN: {
            Method: 'DHCP',
            IPAddress: '',
            Netmask: '',
            Gateway: '',
            Status: ''
        },
        DHCP: {
            DHCPServer: false,
            IPFrom: '',
            IPTo: '',
            Netmask: '',
            Gateway: '',
            DNSServer: '',
            TFTP: ''
        }
    }, {
        key: 'users',
        title: 'USERS',
        description: 'USERS_EXTENSIONS USERS_EXTENSIONS_MODIFICATIONS USERS_DEFAULT_GROUP',
        Optional: false,
        Completed: false,
        AbleToComplete: false,
        InitialValid: false,
        From: '',
        Qtty: '',
        Random: '',
        Password: '',
        RepeatedPassword: ''
    }, {
        key: 'trunks',
        title: 'TRUNKS',
        description: 'TRUNKS_ANALOGUE_PORTS',
        Optional: false,
        Completed: false,
        AbleToComplete: false,
        Trunks: []
    }, {
        key: 'summary',
        title: 'SUMMARY',
        description: 'SUMMARY_CHECK SUMMARY_GOBACK SUMMARY_WAITING',
        Optional: false
    }, {
        key: 'qr',
        title: 'QR',
        description: 'QR_APP QR_APP_DETAIL QR_SCAN',
        Optional: false,
        Hash: '',
        URLSetup: ''
    }, {
        key: 'licence',
        title: 'LICENCE',
        description: 'licence_detail licence_support',
        Optional: true,
        Email: '',
        ActivationCode: ''
    }]
};

export default (state = initialState, action) => {
    switch (action.type) {
        case CHANGE_STEP: {
            return {
                ...state,
                activeStep: action.payload.nextStep
            };
        }
        case UPDATE_STEP: {
            const updatedSteps = updateStep(action, state);

            return {
                ...state,
                steps: updatedSteps
            };
        }
        case GET_SETUP_STATE_REQUEST: {
            return {
                ...state,
                isCompleting: true
            };
        }
        case GET_SETUP_STATE_FAILURE: {
            return {
                ...state,
                isCompleting: false,
                completed: true,
                error: true
            };
        }
        case COMPLETE_SETUP_REQUEST: {
            return {
                ...state,
                completed: false,
                error: false
            };
        }
        case COMPLETE_SETUP_SUCCESS: {
            return {
                ...state,
                isCompleting: false,
                completed: true,
                error: false,
                alternativeEmail: action.payload.companyEmail
            };
        }
        case COMPLETE_SETUP_FAILURE: {
            return {
                ...state,
                isCompleting: false,
                completed: true,
                error: true
            };
        }
        case DECREASE_TIMER: {
            const updatedTimer = updateTimer(action, state);

            return {
                ...state,
                timer: updatedTimer
            };
        }
        case RESEND_VERIFICATION_CODE_REQUEST: {
            return {
                ...state,
                isResending: true,
                resent: false,
                resendError: false
            };
        }
        case RESEND_VERIFICATION_CODE_SUCCESS: {
            return {
                ...state,
                isResending: false,
                resent: true,
                resendError: false,
                alternativeEmail: action.payload.email
            };
        }
        case RESEND_VERIFICATION_CODE_FAILURE: {
            return {
                ...state,
                isResending: false,
                resent: false,
                resendError: true
            };
        }
        case ACTIVATE_DENWA_NANO_REQUEST: {
            return {
                ...state,
                isActivating: true,
                activated: false,
                activationError: false
            };
        }
        case ACTIVATE_DENWA_NANO_SUCCESS: {
            return {
                ...state,
                isActivating: false,
                activated: true,
                activationError: false,
                activationCode: action.payload.activationCode
            };
        }
        case ACTIVATE_DENWA_NANO_FAILURE: {
            return {
                ...state,
                isActivating: false,
                activated: false,
                activationError: true
            };
        }
        case SET_LICENCE_STATUS: {
            return {
                ...state,
                licenceStatus: action.payload.licenceStatus
            }
        }
        case LOG_OUT: {
            return { ...state };
        }
        default:
            return state;
    }
};
